import React, { useCallback, useEffect, useState } from 'react';
import { TextField, Button, Grid, Typography, makeStyles, Container, Box, CircularProgress, Divider } from '@material-ui/core';
import Layout from '../Layout';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import CustomBreadcrumbs from '../Breadcrumb';
import { getAssetDataByVendorCode, getTransferDOA, getVendorData, postTransferReq } from '../../ReduxStore/VendorDataSlice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getUsersforDOA } from '../../ReduxStore/AssetDisposalSlice';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4),
        maxWidth: 800,
        margin: '0 auto',
        paddingBlock: 10,
        marginTop: 5,
        marginBottom: 5
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formControl: {
        // marginBottom: theme.spacing(2),
    },
    button: {
        // marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
}));

const customStyles = {
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    control: (provided) => ({
        ...provided,
        minHeight: '54px',
        height: '54px',
    }),
    valueContainer: (provided) => ({
        ...provided,
        height: '54px',
        padding: '0 8px',
    }),
};

const AssetTransferForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const classes = useStyles();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' }
    ];

    const { response, assetResponse } = useSelector(state => state.vendor);

    const [loading, setLoading] = useState(true);
    const [postLoading, setPostLoading] = useState(false);
    const [SupplierOptions, setSupplierOptions] = useState([]);
    const [AssetOptions, setAssetOptions] = useState([]);
    const [oldVendorLocation, setOldVendorLocation] = useState();
    const [newVendorLocation, setNEWVendorLocation] = useState();
    const [selectedOLdSupplier, setselectedOLdSupplier] = useState();
    const [selectedNewSupplier, setselectedNewSupplier] = useState();
    const [raiser_dept, setRaiserdept] = useState("");
    // const [raiser_name, setRaiserName] = useState();
    const [reason, setReason] = useState();
    const [rows, setRows] = useState([{ asset: null, description: '' }]);

    const [DOA, setDOA] = useState([]);
    const [filteredDOA, setFilteredDOA] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const [usersofVendorOptions, setUserofVendorOptions] = useState([]);
    const [users, setUsers] = useState([]);
    const [usersofvendor, setUsersofvendor] = useState([]);
    const username = localStorage.getItem("username");
    const [businessUnit, setBusinessUnit] = useState(null);

    // Handle asset selection change
    const handleAssetChange = (selectedOption, index) => {
        const updatedRows = [...rows];
        updatedRows[index].asset = selectedOption; // Set the selected asset
        updatedRows[index].description = selectedOption ? selectedOption.description : ''; // Automatically set description
        updatedRows[index].business_unit = selectedOption ? selectedOption.business_unit : ''; // Automatically set description
        setRows(updatedRows);
        const bu = assetResponse[index].business_unit;
        console.log("check", bu)
        setBusinessUnit(bu)
    };

    const [selectedUsers, setSelectedUsers] = useState([]);

    const handleUserChange = (selectedOption, index) => {
        const updatedUsers = [...selectedUsers];
        updatedUsers[index] = {
            id: DOA[index].id,
            levelname: DOA[index].levelname,
            level_sequence: DOA[index].level_sequence,
            user_id: selectedOption ? selectedOption.value : null,
            user_name: selectedOption ? selectedOption.label : null,
            department: DOA[index].department,
            plant_code: DOA[index].plant_code,
        };
        setSelectedUsers(updatedUsers);
    };

    // Add a new row
    const handleAddRow = () => {
        setRows([...rows, { asset: null, description: '' }]);
    };

    // Remove a row
    const handleRemoveRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);
    };

    const handleOldSupplierChange = (selectedOption) => {
        setselectedOLdSupplier(selectedOption);

        // If selectedOption is null (cleared selection), reset the location
        if (!selectedOption) {
            setOldVendorLocation('');
            return;
        }

        // Find the selected supplier's location
        const selectedVendor = response.find(item => item.vendor === selectedOption.value);
        if (selectedVendor) {
            setOldVendorLocation(selectedVendor.location);
        } else {
            setOldVendorLocation(''); // Reset if no supplier found
        }
    };

    const handleNewSupplierChange = (selectedOption) => {
        setselectedNewSupplier(selectedOption);

        // If selectedOption is null (cleared selection), reset the location
        if (!selectedOption) {
            setNEWVendorLocation('');
            return;
        }

        // Find the selected supplier's location
        const selectedVendor = response.find(item => item.vendor === selectedOption.value);
        if (selectedVendor) {
            setNEWVendorLocation(selectedVendor.location);
        } else {
            setNEWVendorLocation(''); // Reset if no supplier found
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!raiser_dept) {
            toast.error("Enter Raiser Department")
            return
        }

        if (selectedUsers.length === 0) {
            toast.error("Please fill DOA")
            return
        }


        const payload = {
            raiser_dept: raiser_dept,
            reason: reason,
            old_vendor_no: selectedOLdSupplier ? selectedOLdSupplier.value : '',
            new_vendor_no: selectedNewSupplier ? selectedNewSupplier.value : '',
            asset_details: rows.map(row => ({
                asset_no: row.asset ? row.asset.value : '',
                description: row.description || ''
            })),
            doa: selectedUsers.map(DOA => ({
                id: DOA.id,
                levelname: DOA.levelname,
                level_sequence: DOA.level_sequence,
                user_id: DOA.user_id,
                user_name: DOA.user_name,
                department: DOA.department,
                plant_code: DOA.plant_code,

            }))
        };

        try {
            setPostLoading(true)
            const action = dispatch(postTransferReq(payload));
            const res = await action.unwrap();
            if (res.StatusCode === 201) {
                setPostLoading(false)
                toast.success("Asset Transfer Requested!");
                setTimeout(() => {
                    navigate("/asset-transfer-table");
                }, 2000);
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        } finally {
            setPostLoading(false)
        }
    };



    useEffect(() => {
        dispatch(getVendorData());
        if (selectedOLdSupplier) {
            dispatch(getAssetDataByVendorCode(selectedOLdSupplier.value));
        }

    }, [dispatch, selectedOLdSupplier])

    useEffect(() => {
        const Supplierlist = response && response.map(item => ({
            label: `${item.vendor_group} (${item.vendor})`,
            value: item.vendor,
            location: item.location // Add location here
        }));
        console.log("Supplierlist", Supplierlist);

        if (Supplierlist) {
            setSupplierOptions(Supplierlist.map((item, index) => ({
                value: item.value,
                label: item.label,
                location: item.location
            })));
        }

        const Assetlist = assetResponse && assetResponse.map(item => ({
            value: item.asset_no,    // Show only the asset
            label: `${(item.asset_no)?.slice(3)} - ${item.description}`,
            description: item.description, // Include the description
            business_unit: item.business_unit // Include the description
        }));
        console.log("Assetlist", Assetlist);

        if (Assetlist) {
            setAssetOptions(Assetlist.map(item => ({
                value: item.value,
                label: item.label,
                description: item.description,
                business_unit: item.business_unit,
            })));
        }


    }, [response, assetResponse]);

    useEffect(() => {
        if (businessUnit) {
            const filteredDOA = DOA && DOA.filter(item => item.plant_code === businessUnit)
            setFilteredDOA(filteredDOA)
        }


    }, [DOA, businessUnit]);

    const getDOAs = async () => {
        try {
            const action = dispatch(getTransferDOA());
            const res = await action.unwrap();
            console.log("DOA res", res.result)
            if (res.result) {
                setDOA(res.result)
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }
    const getUserList = async () => {
        try {
            const action = dispatch(getUsersforDOA(`?customerID=af33f9117ecb4d8d8def84d6331eebd4`));
            const res = await action.unwrap();
            if (res.result) {
                setUsers(res.result)
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    }

    const getUserListofVendor = useCallback(async () => {
        try {
            const action = dispatch(getUsersforDOA(`?customerID=af33f9117ecb4d8d8def84d6331eebd4&vendor_code=${selectedNewSupplier.value}`));
            const res = await action.unwrap();
            if (res.result) {
                setUsersofvendor(res.result)
            }
        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
    }, [dispatch, selectedNewSupplier])

    useEffect(() => {
        const fetchData = async () => {
            await getDOAs();
            await getUserList();
            setLoading(false);
        };
        fetchData();
    }, [])

    useEffect(() => {
        if (selectedNewSupplier) {
            getUserListofVendor();
        }
    }, [getUserListofVendor, selectedNewSupplier])

    useEffect(() => {
        if (users.length > 0) {
            const UserList = users && users.map(item => ({
                value: item.id,
                label: item.name,
            }));



            if (UserList) {
                setUserOptions(UserList.map(item => ({
                    value: item.value,
                    label: item.label,
                })));
            }
        }
        if (usersofvendor.length > 0) {
            const UserList = usersofvendor && usersofvendor.map(item => ({
                value: item.id,
                label: item.name,
            }));



            if (UserList) {
                setUserofVendorOptions(UserList.map(item => ({
                    value: item.value,
                    label: item.label,
                })));
            }
        }


    }, [users, usersofvendor]);




    // const theme = useTheme();
    // const isXs = useMediaQuery(theme.breakpoints.down('xs'));
    // const isSm = useMediaQuery(theme.breakpoints.down('sm'));


    // let variant = "h3";
    // if (isXs) {
    //     variant = "h4"; // For extra-small screens
    // } else if (isSm) {
    //     variant = "h4"; // For small screens
    // }


    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <ResponsiveTypography>
                        Asset Transfer Form
                    </ResponsiveTypography>
                </Box> */}
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Asset Transfer Form" />
                </Box>
                <Box mb={2}>
                    <Grid container>
                        <form className={classes.form}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <Select
                                        styles={customStyles}
                                        options={SupplierOptions}
                                        placeholder="Select Current Vendor"
                                        isSearchable
                                        onChange={handleOldSupplierChange}
                                        isClearable
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Current Location"
                                        variant="outlined"
                                        value={oldVendorLocation}
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                            style: { fontWeight: 'bold' } // Makes the label bold
                                        }}
                                        inputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Requestor Name"
                                        name="RequestorName"
                                        variant="outlined"
                                        value={username}
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                            style: { fontWeight: 'bold' }
                                        }}
                                        fullWidth
                                        inputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Requestor Department"
                                        name="RequestorDepartment"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                            style: { fontWeight: 'bold' }
                                        }}
                                        value={raiser_dept}
                                        required
                                        onChange={(e) => setRaiserdept(e.target.value)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Select
                                        styles={customStyles}
                                        options={SupplierOptions}
                                        placeholder="Select New Vendor"
                                        isSearchable
                                        onChange={handleNewSupplierChange}
                                        isClearable
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        className={classes.formControl}
                                        label="New Vendor Location"
                                        name="CurrentLocation"
                                        variant="outlined"
                                        value={newVendorLocation}
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                            style: { fontWeight: 'bold' }
                                        }}
                                        inputProps={{ readOnly: true }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Reason"
                                        name="reason"
                                        variant="outlined"
                                        value={reason}
                                        onChange={(e) => setReason(e.target.value)}
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true, // Ensures the label doesn't overlap when field is populated
                                            style: { fontWeight: 'bold' }
                                        }}
                                        multiline
                                        rows={4}
                                    />
                                </Grid>
                            </Grid>
                        </form>
                    </Grid>
                </Box>
                <Box mb={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            <Typography variant="h6" gutterBottom>
                                Asset Details
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleAddRow}
                                style={{ marginRight: 8 }}
                            >
                                Add Row
                            </Button>
                        </Grid>
                    </Grid>
                    {rows.map((row, index) => (
                        <Grid container spacing={2} key={index}>
                            <Grid item xs={12} sm={4}>
                                <Select
                                    styles={customStyles}
                                    options={AssetOptions}
                                    placeholder="Select Asset"
                                    isSearchable
                                    isClearable
                                    value={row.asset}
                                    onChange={(selectedOption) => handleAssetChange(selectedOption, index)}
                                    menuPlacement="auto"
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    label="Asset Description"
                                    variant="outlined"
                                    fullWidth
                                    value={row.description}
                                    InputLabelProps={{
                                        shrink: true, // Ensures the label doesn't overlap when field is populated
                                        style: { fontWeight: 'bold' }
                                    }}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={1}>
                                <TextField
                                    label="Plant Code"
                                    variant="outlined"
                                    fullWidth
                                    value={row.business_unit}
                                    InputLabelProps={{
                                        shrink: true, // Ensures the label doesn't overlap when field is populated
                                        style: { fontWeight: 'bold' }
                                    }}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => handleRemoveRow(index)}
                                    disabled={rows.length === 1} // Prevent removing the last row
                                >
                                    Remove Row
                                </Button>
                            </Grid>
                        </Grid>
                    ))}
                </Box>
                {businessUnit && <Box
                    mb={2}
                    border={2}
                    borderColor="grey.300"
                    borderRadius={4}
                    p={2}
                    className="table-container"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h6" gutterBottom>
                                DOA
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container spacing={3} className="checkpoint-header" alignItems="center" style={{ backgroundColor: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
                        <Grid item xs={2}>
                            <Typography variant="subtitle1" component="h3" style={{ fontWeight: 'bold' }}>
                                Level Seq.
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography variant="subtitle1" component="h3" style={{ fontWeight: 'bold' }}>
                                Level Name
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="subtitle1" component="h3" style={{ fontWeight: 'bold' }}>
                                User Name
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography variant="subtitle1" component="h3" style={{ fontWeight: 'bold' }}>
                                Department
                            </Typography>
                        </Grid>
                        {/* <Grid item xs={2}>
                            <Typography variant="subtitle1" component="h3" style={{ fontWeight: 'bold' }}>
                                Plant Code
                            </Typography>
                        </Grid> */}
                    </Grid>

                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                    <Box className="table-content">
                        {filteredDOA && filteredDOA.map((item, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <Grid container spacing={2} alignItems="center" style={{ padding: '10px 0' }}>
                                        <Grid item xs={2}>
                                            <Typography>{item.level_sequence}</Typography>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Typography>{item.levelname}</Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Select
                                                // options={userOptions}
                                                options={item.levelname === 'Supplier' ? usersofVendorOptions : userOptions}
                                                placeholder="Select User"
                                                isSearchable
                                                isClearable
                                                menuPlacement="auto"
                                                onChange={(selectedOption) => handleUserChange(selectedOption, index)}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Typography>{item.department}</Typography>
                                        </Grid>
                                        {/* <Grid item xs={2}>
                                            <Typography>{item.plant_code}</Typography>
                                        </Grid> */}
                                    </Grid>
                                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                                </React.Fragment>
                            )
                        })}

                    </Box>
                </Box>}

                <Grid container>
                    <Grid item>
                        <Button
                            className={classes.button}
                            type="submit"
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            fullWidth
                            startIcon={postLoading && <CircularProgress size={20} />}
                            disabled={postLoading}
                        >
                            {postLoading ? "Submitting" : "Submit"}
                        </Button>
                    </Grid>
                </Grid>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default AssetTransferForm;
